var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"fs-card property-map",staticStyle:{"height":"100%"}},[_c('google-map-loader',{attrs:{"mapConfig":_vm.mapConfig},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var google = ref.google;
var map = ref.map;
return _vm._l((_vm.markers),function(marker){return _c('google-map-marker',{key:marker.id,attrs:{"marker":marker,"google":google,"map":map,"infoWindow":_vm.infoWindow}})})}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }